export class HeightCalculationUtils {
  static calculateTotalHeight(): number {
    const alertHeight =
      document.querySelector('.alert-advisory-main-container')?.scrollHeight ??
      0;
    const headerHeight = this.getHeaderHeight();
    return alertHeight + headerHeight;
  }

  static getHeaderHeight(): number {
    const navHeight = document.querySelector('.navbar')?.scrollHeight ?? 0;
    const headerTopHeight =
      document.querySelector('.header__top')?.scrollHeight ?? 0;
    return navHeight || headerTopHeight;
  }

  static getModalTop(totalHeight: number, innerWidth: number): string {
    return innerWidth <= 767 ? '0px' : `${totalHeight}px`;
  }
}
